import React from 'react';
import { Percent, TrendingUp } from 'lucide-react';
import { FilingPanel, YearTable } from './FilingPanel';

/** Restated financials and ratio KPIs, exactly as extracted from the filing. */
export const FilingFinancials = ({ financials, kpis }) => {
  if (!financials && !kpis) return null;

  return (
    <div className="space-y-4 sm:space-y-5">
      {financials && (
        <FilingPanel
          id="filing-financials-heading"
          title="Restated Financials"
          icon={TrendingUp}
          action={
            financials.unit && (
              <span className="px-2 py-0.5 rounded-md bg-slate-100 text-[10px] font-bold text-slate-600 normal-case">
                Figures in {financials.unit}
              </span>
            )
          }
          note="Read off the restated summary in the offer document by an automated extractor. Verify against the filing before use."
        >
          <YearTable years={financials.years} rows={financials.rows} caption="Restated financial summary by year" />
        </FilingPanel>
      )}

      {kpis && (
        <FilingPanel id="filing-kpis-heading" title="Ratio Analysis" icon={Percent}>
          <YearTable years={kpis.years} rows={kpis.rows} caption="Key ratios by year" />
        </FilingPanel>
      )}
    </div>
  );
};

export default FilingFinancials;
